// Used for account number confirmation.
export enum BankAccountNumberConfirmationFormFields {
  MANUAL_BANK_ACCOUNT_NUMBER = "manualBankAccountNumber",
  MANUAL_RE_BANK_ACCOUNT_NUMBER = "manualReBankAccountNumber",
}

export interface StateToActionMapping {
  [state: string]: any;
}
